import * as React from 'react';
import { FlexRowCenterVertical, FlexCol } from '../../Defaults/Flexbox/Flexbox';
import styled from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import { __ } from 'react-i18n';
import { SvgIcon, IconType } from '../General/SvgIcon';

interface Props {
  title: string;
  children: any;
  handleClose: any;
}

function MobileCategoryFilterMenu({ title, children, handleClose }: Props) {
  return (
    <Wrapper>
      <IconTitleWrapper>
        <Title>{title}</Title>
        <CloseIcon
          icon={IconType.close}
          alt="Zavrieť menu"
          cursor={'pointer'}
          onClick={handleClose}
        />
      </IconTitleWrapper>
      {children}
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)``;

const IconTitleWrapper = styled(FlexRowCenterVertical)`
  width: 100%;
  justify-content: space-between;
  padding: 0 ${rem(16)} ${rem(26)};
`;

const Title = styled(TextP)`
  font-size: ${rem(18)};
  font-family: ${({ theme }) => theme.font.secondary};
  line-height: ${rem(24)};
  color: ${({ theme }) => theme.colors.black};
  font-weight: 500;
`;

const CloseIcon = styled(SvgIcon)`
  fill: ${({ theme }) => theme.colors.black};
`;

export { MobileCategoryFilterMenu as SanitasMobileCategoryFilterMenu };
